import React from 'react';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { CheckIcon } from 'src/assets/dynamicSvg';
import { Poppins } from 'src/common';

const Div = styled.div<{ $center?: boolean }>`
  display: flex;
  align-items: ${({ $center }) => ($center ? 'center' : 'flex-start')};
  gap: 12px;
  flex: 1;

  .toast-icon {
    flex-shrink: 0;
  }

  .toast-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
  }

  .toast-title {
    font-family: Poppins, sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.prussianBlue};
  }

  .toast-subtitle {
    font-family: Poppins, sans-serif;
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.colors.cflowerBlue};
    line-height: 1.4;
  }
`;

interface SuccessToastProps {
  title?: string;
  subtitle?: string;
}

const SuccessToastContent: React.FC<SuccessToastProps> = ({
  title = 'Item has been updated successfully!',
  subtitle,
}) => {
  return (
    <Div $center={!subtitle}>
      <div className="toast-icon">
        <CheckIcon color="statusGreen" style={{ width: 32, height: 32 }} />
      </div>
      <div className="toast-content">
        <Poppins weight={600}>{title}</Poppins>
        {subtitle && <span className="toast-subtitle">{subtitle}</span>}
      </div>
    </Div>
  );
};

export const showSuccessToast = (overrides?: SuccessToastProps) => {
  toast(<SuccessToastContent {...overrides} />, {
    type: 'success',
    icon: false,
  });
};

const PENDING_TOAST_KEY = 'pendingSuccessToast';

export const queueSuccessToast = (overrides: SuccessToastProps) => {
  localStorage.setItem(PENDING_TOAST_KEY, JSON.stringify(overrides));
};

export const flushPendingToast = () => {
  const raw = localStorage.getItem(PENDING_TOAST_KEY);
  if (raw) {
    localStorage.removeItem(PENDING_TOAST_KEY);
    try {
      showSuccessToast(JSON.parse(raw));
    } catch {
      // ignore malformed data
    }
  }
};
